import React, { useState } from "react";
import { FileText, FileEdit, User, X } from "lucide-react";
import AppoinmentDetails from "./AppoinmentDetails";
import "./ConsultationSidePanel.scss";
import { AppoinmentDetailIcon, AppoinmentDetailIconWhite } from "./Icons";

const ConsultationSidePanel = ({ appointmentData, onClose, activeTabProp }) => {
  console.log("Appointment Data:", appointmentData);
  const [activeTab, setActiveTab] = useState(activeTabProp || "info"); // 'info' or 'prescription'

  return (
    <div className="consultation-side-panel">
      <button
        className="close-button"
        onClick={onClose}
        aria-label="Close panel"
      >
        <X size={20} />
      </button>

      {/* Content Area */}
      <div className="panel-content">
        {activeTab === "info" ? (
          <AppoinmentDetails appointmentData={appointmentData} />
        ) : (
          <AppoinmentDetails appointmentData={appointmentData} />
        )}
      </div>

      {/* Bottom Tabs — always render BOTH */}
      <div className="bottom-tabs">
        <button onClick={() => setActiveTab("info")} className="tab-button">
          <div
            className={`control-button ${activeTab === "info" ? "active" : ""}`}
          >
            <div className="icon-wrapper">
              <AppoinmentDetailIconWhite />
            </div>
            <div className="text-wrapper">
              <div>Appointment</div>
              <div>Information</div>
            </div>
          </div>
        </button>

        <button
          onClick={() => setActiveTab("prescription")}
          className="tab-button"
        >
          <div
            className={`control-button ${activeTab === "prescription" ? "active" : ""}`}
          >
            <div className="icon-wrapper">
              <FileEdit size={24} />
            </div>
            <div className="text-wrapper">
              <div>Create a</div>
              <div>Prescription</div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ConsultationSidePanel;
